import { create } from 'zustand'

import { InviteCreationStage } from '../lib/types'

type UserProfileStore = {
  isError: boolean
  setIsError: (isError: boolean) => void
  errorTitle: string | null
  setErrorTitle: (errorTitle: string | null) => void
  inviteCreationStage: InviteCreationStage
  setInviteCreationStage: (stage: InviteCreationStage) => void
  sentInvitePermissionsExpiresAt: string | null
  setSentInvitePermissionsExpiresAt: (value: string | null) => void
}

export const useUserProfileStore = create<UserProfileStore>(set => ({
  isError: false,
  setIsError: isError => set(() => ({ isError })),
  errorTitle: null,
  setErrorTitle: errorTitle => set(() => ({ errorTitle })),
  inviteCreationStage: InviteCreationStage.Create,
  setInviteCreationStage: stage => set(() => ({ inviteCreationStage: stage })),
  sentInvitePermissionsExpiresAt: null,
  setSentInvitePermissionsExpiresAt: value =>
    set(() => ({ sentInvitePermissionsExpiresAt: value }))
}))
